<template>
  <div class="goods-action" v-if="detailList">
    <div class="goods-action-item customer-service">
      <span class="goods-action-icon">
        <img src="../../../../assets/images/customer-service.png" alt="">
      </span>
      <p class="customer-service-p">客服</p>
    </div>
    <div class="goods-action-item customer-car">
      <router-link :to="{path: '/car'}">
      <span class="goods-action-icon" :class="{animate: animations}">
        <img src="../../../../assets/images/user-car-icon.png" alt="">
      </span>
      <p class="cart-p">购物车</p>
      <!-- 右上角数字 -->
      <span class="badge">{{carLength || 0}}</span>
      </router-link>
    </div>
    <div class="goods-action-item" v-if="detailList.groupBuy && !detailList.groupBuy.groupBuyComm">
      <van-button class="add-car-btn" type="default" @click="showSku('jumpCar')">加入购物车</van-button>
    </div>
    <div class="goods-action-item" >
      <van-button :class="detailList.groupBuy && detailList.groupBuy.groupBuyComm ? 'add-car-btn' :'purchase-btn'" type="default" @click="showSku('jumpConfirmOrder')">{{detailList.groupBuy && detailList.groupBuy.groupBuyComm ? '原价购买' : '立即购买'}}</van-button>
    </div>
    <div class="goods-action-item" v-if="detailList.groupBuy && detailList.groupBuy.groupBuyComm">
      <van-button class="purchase-btn" type="default" @click="showSku('group')">发起拼团</van-button>
    </div>

  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
export default {
  data() {
    return {
      animations: false
    };
  },
  props: ['detailList'],
  computed: {
    ...mapState({
      carLength: state => state.carLength
    })
  },
  created() {
    this.getCarlist()
  },
  methods: {
    // 点击加入购物车，立即购买弹出弹框  传参，成功后跳转页面页面不同
    showSku(jumpType){
      this.$emit("showPopup", jumpType)
    },
    ...mapActions({
      getCarlist: 'getCarlist'
    }),
    // 设置加入购物车成功是抖动动画
    setCarAnimation() {
      this.animations = true;
      setTimeout(()=> {
        this.animations = false;
      },1000)
    }
  }
};
</script>
<style lang="scss" scoped>
.goods-action {
  width: 100%;
  max-width: 750px;
  // height: 98px;
  border:none;
  border-top: 1px solid $bc01;
  display: flex;
  background: $bg02;
  padding: 8px 30px 10px 40px;
  box-sizing: border-box;
  position: fixed;
  justify-content: space-around;
  align-items: center;
  bottom: 0;
  .goods-action-item {
    text-align: center;
    line-height: 1;
    .goods-action-icon {
      width: 50px;
      height: 50px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .customer-service-p{
      color: $fc01;
    }
    .cart-p{
      color: $fc06;
    }
    p{
      font-size: 20px;
    }
    button{
      width: 220px;
      height: 80px;
      line-height: 80px;
      border-radius: $br40;
      color: $fc02;
      font-size: 30px;
      border: none;
    }
    .add-car-btn{
      background: $btn02;
      margin: 0 20px 0 56px;
      &:active{
        background: $btnHover02;
      }
    }
    .purchase-btn{
      background: $btn01;
      &:active{
        background: $btnHover01;
      }
    }
    .badge{
      width: 25px;
      height: 25px;
      line-height: 26px;
      /*padding: 4px;*/
      font-size: 16px;
      text-align: center;
      background: $btn02;
      position: absolute;
      top: 0;
      right: -4px;
      color: $fc02;
      border-radius:25px;
      overflow: hidden;
      display: inline-block;
    }
  }
  .animate{
    -webkit-animation-name: tada;
    animation-name: tada;
    -webkit-animation-duration: 1.3s;
    animation-duration: 1.3s;
    -webkit-animation-timing-function: ease-in-out;
    animation-timing-function: ease-in-out;
  }
  @-webkit-keyframes tada {
    from {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }

    10%,
    20% {
      -webkit-transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
      transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
    }

    30%,
    50%,
    70%,
    90% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
    }

    40%,
    60%,
    80% {
      -webkit-transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
      transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
    }

    to {
      -webkit-transform: scale3d(1, 1, 1);
      transform: scale3d(1, 1, 1);
    }
  }

  .customer-car{
    margin-left: 40px;
    position: relative;
  }
}
</style>


